module.exports = __webpack_public_path__ + "assets/clickTask.93e8c471.svg";